import { Mail, ExternalLink } from 'lucide-react';
import { Link } from 'react-router-dom';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  const amazonStoreUrl = "https://www.amazon.com/stores/TRENDO/page/3D435283-278E-44B3-83C7-66C5C0BCC5C0?lp_asin=B0DRT7VDLX&ref_=ast_bln&store_ref=bl_ast_dp_brandLogo_sto";

  return (
    <footer className="bg-slate-50 border-t border-slate-200" data-testid="footer">
      {/* CTA Section */}
      <div className="bg-[#0F172A] text-white py-16">
        <div className="max-w-7xl mx-auto px-6 md:px-12 text-center">
          <h2 className="font-heading text-3xl md:text-4xl font-bold mb-4" data-testid="footer-cta-heading">
            Partner with Snappadeal
          </h2>
          <p className="text-slate-300 text-lg mb-8 max-w-2xl mx-auto" data-testid="footer-cta-description">
            Shop TRENDO on Amazon or work with our software consulting team. Quality and expertise you can trust.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href={amazonStoreUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 bg-[#FF9900] text-slate-900 hover:bg-[#FFB84D] rounded-full px-8 py-4 font-bold shadow-lg shadow-orange-500/20 hover:shadow-orange-500/40 transition-all duration-300 hover:-translate-y-1 text-lg"
              data-testid="footer-amazon-button"
            >
              <svg viewBox="0 0 24 24" className="w-6 h-6" fill="currentColor">
                <path d="M.045 18.02c.072-.116.187-.124.348-.022 3.636 2.11 7.594 3.166 11.87 3.166 2.852 0 5.668-.533 8.447-1.595l.315-.14c.138-.06.234-.1.293-.13.226-.088.39-.046.525.13.12.174.09.336-.12.48-.256.19-.6.41-1.006.654-1.244.748-2.143 1.18-2.693 1.295-.547.114-1.35.244-2.405.394-.883.1-1.793.15-2.73.15-2.097 0-4.17-.34-6.217-1.022-2.293-.763-4.33-1.86-6.107-3.296-.11-.1-.135-.2-.075-.298zm6.965-2.485c-.68-.058-1.236-.232-1.67-.53-.434-.297-.77-.734-1.012-1.31-.242-.576-.363-1.26-.363-2.049 0-1.156.33-2.136.988-2.941.658-.805 1.524-1.21 2.594-1.21.32 0 .613.03.876.092.264.06.5.15.707.27.208.12.377.253.506.4.13.147.23.304.3.47l.157-.41c.07-.17.138-.32.2-.45.06-.13.148-.27.268-.42.12-.15.26-.27.418-.36.16-.09.366-.14.62-.14.253 0 .47.05.65.15.18.1.313.248.4.443.086.196.13.4.13.615v6.52c0 1.226-.34 2.175-1.015 2.846-.676.672-1.62 1.008-2.836 1.008-.472 0-.94-.05-1.397-.15-.46-.1-.85-.26-1.178-.48-.327-.22-.58-.49-.756-.81-.176-.32-.265-.69-.265-1.11 0-.32.067-.6.2-.84.134-.24.317-.43.55-.57.232-.14.5-.24.8-.31.302-.07.62-.105.957-.105h1.82v-.39c0-.503-.1-.886-.296-1.148-.198-.263-.515-.394-.953-.394-.316 0-.575.06-.774.18-.2.12-.35.3-.453.54l-1.678-.336c.177-.612.515-1.087 1.014-1.426.5-.34 1.12-.508 1.862-.508.82 0 1.468.195 1.945.586.476.39.714.943.714 1.66v3.82c0 .25.053.427.16.53.107.105.275.157.504.157.123 0 .263-.02.42-.06v1.21c-.27.08-.556.12-.856.12-.59 0-1.044-.143-1.364-.43-.32-.285-.48-.68-.48-1.185v-.15c-.187.432-.48.775-.88 1.03-.4.253-.88.38-1.44.38zm1.86-2.97c-.328 0-.583.07-.765.21-.182.14-.273.34-.273.6 0 .26.088.46.263.6.176.14.42.21.73.21.31 0 .585-.073.823-.22.237-.147.42-.343.548-.59.128-.246.192-.513.192-.8v-.01h-1.52zm5.246 2.07l-2.096-6.76h1.844l1.26 4.62 1.32-4.62h1.74l1.3 4.62 1.278-4.62h1.826l-2.124 6.76h-1.814l-1.37-4.52-1.35 4.52h-1.814z"/>
              </svg>
              Shop TRENDO on Amazon
              <ExternalLink size={18} />
            </a>
            <a
              href="#contact"
              className="inline-flex items-center justify-center bg-[#10B981] text-white hover:bg-[#059669] rounded-full px-8 py-4 font-bold shadow-lg shadow-green-500/20 hover:shadow-green-500/40 transition-all duration-300 hover:-translate-y-1 text-lg"
              data-testid="footer-cta-button"
            >
              Contact Us
            </a>
          </div>
        </div>
      </div>

      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Company */}
          <div className="md:col-span-2">
            <h3 className="font-heading font-bold text-xl mb-4" data-testid="footer-company-heading">
              Snappadeal
            </h3>
            <p className="text-slate-600 mb-4 max-w-md">
              <strong>TRENDO</strong> brand on Amazon + Software development and testing consulting services. Excellence in e-commerce and technology.
            </p>
            <div className="flex items-center text-slate-600 mb-4">
              <Mail size={16} className="mr-2" />
              <a href="mailto:contact@snappadeal.com" className="hover:text-slate-900" data-testid="footer-email">
                contact@snappadeal.com
              </a>
            </div>
            {/* Amazon Store Link */}
            <a
              href={amazonStoreUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 text-[#FF9900] hover:text-[#CC7A00] font-medium"
              data-testid="footer-amazon-link"
            >
              <svg viewBox="0 0 24 24" className="w-5 h-5" fill="currentColor">
                <path d="M.045 18.02c.072-.116.187-.124.348-.022 3.636 2.11 7.594 3.166 11.87 3.166 2.852 0 5.668-.533 8.447-1.595l.315-.14c.138-.06.234-.1.293-.13.226-.088.39-.046.525.13.12.174.09.336-.12.48-.256.19-.6.41-1.006.654-1.244.748-2.143 1.18-2.693 1.295-.547.114-1.35.244-2.405.394-.883.1-1.793.15-2.73.15-2.097 0-4.17-.34-6.217-1.022-2.293-.763-4.33-1.86-6.107-3.296-.11-.1-.135-.2-.075-.298zm6.965-2.485c-.68-.058-1.236-.232-1.67-.53-.434-.297-.77-.734-1.012-1.31-.242-.576-.363-1.26-.363-2.049 0-1.156.33-2.136.988-2.941.658-.805 1.524-1.21 2.594-1.21.32 0 .613.03.876.092.264.06.5.15.707.27.208.12.377.253.506.4.13.147.23.304.3.47l.157-.41c.07-.17.138-.32.2-.45.06-.13.148-.27.268-.42.12-.15.26-.27.418-.36.16-.09.366-.14.62-.14.253 0 .47.05.65.15.18.1.313.248.4.443.086.196.13.4.13.615v6.52c0 1.226-.34 2.175-1.015 2.846-.676.672-1.62 1.008-2.836 1.008-.472 0-.94-.05-1.397-.15-.46-.1-.85-.26-1.178-.48-.327-.22-.58-.49-.756-.81-.176-.32-.265-.69-.265-1.11 0-.32.067-.6.2-.84.134-.24.317-.43.55-.57.232-.14.5-.24.8-.31.302-.07.62-.105.957-.105h1.82v-.39c0-.503-.1-.886-.296-1.148-.198-.263-.515-.394-.953-.394-.316 0-.575.06-.774.18-.2.12-.35.3-.453.54l-1.678-.336c.177-.612.515-1.087 1.014-1.426.5-.34 1.12-.508 1.862-.508.82 0 1.468.195 1.945.586.476.39.714.943.714 1.66v3.82c0 .25.053.427.16.53.107.105.275.157.504.157.123 0 .263-.02.42-.06v1.21c-.27.08-.556.12-.856.12-.59 0-1.044-.143-1.364-.43-.32-.285-.48-.68-.48-1.185v-.15c-.187.432-.48.775-.88 1.03-.4.253-.88.38-1.44.38zm1.86-2.97c-.328 0-.583.07-.765.21-.182.14-.273.34-.273.6 0 .26.088.46.263.6.176.14.42.21.73.21.31 0 .585-.073.823-.22.237-.147.42-.343.548-.59.128-.246.192-.513.192-.8v-.01h-1.52zm5.246 2.07l-2.096-6.76h1.844l1.26 4.62 1.32-4.62h1.74l1.3 4.62 1.278-4.62h1.826l-2.124 6.76h-1.814l-1.37-4.52-1.35 4.52h-1.814z"/>
              </svg>
              Visit TRENDO Store on Amazon
              <ExternalLink size={14} />
            </a>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-heading font-bold text-lg mb-4" data-testid="footer-platforms-heading">What We Offer</h4>
            <ul className="space-y-2 text-slate-600">
              <li>
                <a 
                  href={amazonStoreUrl} 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="hover:text-slate-900 inline-flex items-center gap-1"
                >
                  TRENDO - Amazon Brand
                  <ExternalLink size={12} />
                </a>
              </li>
              <li>Software Development</li>
              <li>Software Testing</li>
              <li>IT Consulting</li>
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading font-bold text-lg mb-4" data-testid="footer-links-heading">Quick Links</h4>
            <ul className="space-y-2 text-slate-600">
              <li><a href="#about" className="hover:text-slate-900">About</a></li>
              <li><a href="#services" className="hover:text-slate-900">Services</a></li>
              <li><a href="#faq" className="hover:text-slate-900">FAQ</a></li>
              <li><a href="#contact" className="hover:text-slate-900">Contact</a></li>
              <li>
                <Link to="/privacy" className="hover:text-slate-900" data-testid="footer-privacy-link">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" className="hover:text-slate-900" data-testid="footer-terms-link">
                  Terms of Service
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-200 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-slate-600">
          <p data-testid="footer-copyright">&copy; {currentYear} Snappadeal. All rights reserved.</p>
          <div className="flex gap-6 text-sm">
            <Link to="/privacy" className="hover:text-slate-900">Privacy</Link>
            <Link to="/terms" className="hover:text-slate-900">Terms</Link>
            <a 
              href={amazonStoreUrl} 
              target="_blank" 
              rel="noopener noreferrer" 
              className="hover:text-slate-900 inline-flex items-center gap-1"
            >
              Amazon Store
              <ExternalLink size={12} />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};
